import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

//Vuex
// import store from '../store'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        children: [{
                path: '/',
                name: 'projets',
                component: () =>
                    import ('../views/Projects.vue')
            },
            {
                path: '/project/:nameProyect',
                name: 'projet',
                component: () =>
                    import ('../views/ViewProject.vue'),
            },
            {
                path: '/proyectdetails',
                name: 'ProyectDetails',
                component: () =>
                    import ('../views/ProyectDetails.vue')
            },
            {
                path: '/calendar',
                name: 'Calendar',
                component: () =>
                    import ('../views/Calendar.vue')
            },
            {
                path: '/accountsettings',
                name: 'AccountSettings',
                component: () =>
                    import ('../views/AccountSettings.vue')
            },
        ],
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('SesionToken')) {
                next()
                return
            }
            next('/login')

        }
    },
    {
        path: '/Login',
        name: 'Login',

        component: () =>
            import ('../views/Login.vue'),
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('SesionToken')) {
                next('/')
                return
            }
            next()
        }
    },
    {
        path: '/RecoverPassword',
        name: 'RecoverPassword',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/RecoverPassword.vue'),
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('SesionToken')) {
                next('/')
                return
            }
            next()
        }
    },
]




const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router